module.exports = __webpack_public_path__ + "img/07.20397f85.jpg";